import type { IUser } from '../types';
import { isLocalStorageSupported, isSessionStorageSupported, isIndexedDBSupported } from '@roai/shared';

export async function getUserInfo(): Promise<IUser> {
  return {
    da: navigator.language,
    db: navigator.languages.join(','),
    dc: isLocalStorageSupported(),
    dd: isSessionStorageSupported(),
    de: await isIndexedDBSupported(),
  }
}
